(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('.blog-wrapper--gallery .blog-images');
    const slider = gallery?.querySelector('.blog-images__track');
    if (!gallery || !slider) return;

    const $slider = $(slider);
    const $gallery = $(gallery);
    const $prevBtn = $gallery.find('.blog-images__nav--prev');
    const $nextBtn = $gallery.find('.blog-images__nav--next');
    const slideCount = $slider.children().length;

    if (slideCount <= 1) {
      $prevBtn.remove();
      $nextBtn.remove();
      return;
    }

    const desktopQuery = window.matchMedia('(min-width: 750px)');

    function getListPaddingLeft(slideIndex) {
      if (!desktopQuery.matches) return null;
      return slideIndex === 0 ? '30%' : '26px';
    }

    function applyListPadding(slideIndex, recalculate) {
      const $list = $slider.find('.slick-list');

      if (!desktopQuery.matches) {
        $list.css({
          paddingLeft: '',
          paddingRight: '',
          paddingTop: '',
          paddingBottom: '',
        });
      } else {
        $list.css({
          paddingLeft: getListPaddingLeft(slideIndex),
          paddingRight: '26px',
          paddingTop: '22px',
          paddingBottom: '22px',
        });
      }

      if (recalculate && $slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    }

    $slider.on('init reInit', (_event, slick) => {
      applyListPadding(slick.currentSlide, false);
    });

    $slider.on('beforeChange', (_event, _slick, _currentSlide, nextSlide) => {
      applyListPadding(nextSlide, true);
    });

    $slider.slick({
      variableWidth: true,
      slidesToShow: 1,
      infinite: false,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $prevBtn,
      nextArrow: $nextBtn,
      draggable: true,
      swipe: true,
      touchMove: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            variableWidth: false,
          },
        },
      ],
    });

    slider.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', () => {
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('setPosition');
          }
        }, { once: true });
      }
    });

    window.addEventListener('load', () => {
      if ($slider.hasClass('slick-initialized')) {
        applyListPadding($slider.slick('slickCurrentSlide'), true);
      }
    });

    desktopQuery.addEventListener('change', () => {
      if ($slider.hasClass('slick-initialized')) {
        applyListPadding($slider.slick('slickCurrentSlide'), true);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    const slickOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
    };

    function initMobileCarousels() {
      $('.collection-product__carousel--mobile').each(function () {
        const $carousel = $(this);

        if ($carousel.hasClass('slick-initialized')) {
          return;
        }

        $carousel.slick(slickOptions);
      });
    }

    function initDesktopCarousels() {
      $('.collection-product__carousel--desktop').each(function () {
        const $carousel = $(this);
        const $wrapper = $carousel.closest('.collection-product__image-wrapper');

        if ($carousel.hasClass('slick-initialized')) {
          return;
        }

        $carousel.slick(slickOptions);

        $wrapper
          .off('mouseenter.collectionCarousel mouseleave.collectionCarousel')
          .on('mouseenter.collectionCarousel', () => {
            if ($carousel.hasClass('slick-initialized')) {
              $carousel.slick('setPosition');
            }
          })
          .on('mouseleave.collectionCarousel', () => {
            if ($carousel.hasClass('slick-initialized')) {
              $carousel.slick('slickGoTo', 0, true);
            }
          });
      });
    }

    function destroyCarousels(selector) {
      $(selector).each(function () {
        const $carousel = $(this);

        $carousel.closest('.collection-product__image-wrapper').off('mouseenter.collectionCarousel mouseleave.collectionCarousel');

        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      });
    }

    function initCarousels() {
      if (desktopQuery.matches) {
        destroyCarousels('.collection-product__carousel--mobile');
        initDesktopCarousels();
      } else {
        destroyCarousels('.collection-product__carousel--desktop');
        initMobileCarousels();
      }
    }

    initCarousels();

    window.addEventListener('load', () => {
      const selector = desktopQuery.matches
        ? '.collection-product__carousel--desktop'
        : '.collection-product__carousel--mobile';

      $(selector).each(function () {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('setPosition');
        }
      });
    });

    desktopQuery.addEventListener('change', initCarousels);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const hamburger = document.querySelector(".hamburger");
  const mobileMenu = document.querySelector(".mobile-menu");
  const iconHamburger = document.querySelector(".icon-hamburger");
  const iconClose = document.querySelector(".icon-close");

  if (hamburger && mobileMenu) {
    hamburger.addEventListener("click", () => {
      const isActive = hamburger.classList.toggle("active");
      mobileMenu.classList.toggle("open");

      // Toggle SVGs manually (ensures visibility updates immediately)
      if (isActive) {
        iconHamburger.style.display = "none";
        iconClose.style.display = "block";
      } else {
        iconHamburger.style.display = "block";
        iconClose.style.display = "none";
      }

      // Ensure menu appears above header
      if (mobileMenu.classList.contains("open")) {
        mobileMenu.style.display = "flex";
      } else {
        mobileMenu.style.display = "none";
      }
    });
  }
});
  // --- Cart Drawer Trigger ---
    const headerCartButton = document.getElementById("HeaderCartButton");
  const cartDrawer = document.getElementById("CartDrawer");

  if (headerCartButton && cartDrawer) {
    headerCartButton.addEventListener("click", (e) => {
      e.preventDefault(); // prevent redirect to cart page
      cartDrawer.classList.add("active");
    });
  }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {

    const productForm = document.querySelector('[id^="product-form-"]');
    const cartDrawer = document.getElementById("CartDrawer");

    if (!productForm || !cartDrawer) return;

    const addToCartButton = productForm.querySelector('.add-to-cart-button');
    
    function updateButtonState(variantId) {
      if (!variantId) {
        addToCartButton.disabled = true;
        addToCartButton.textContent = 'Sold out';
        return;
      }

      const variant = window.ProductVariants.find(v => v.id === variantId);
      
      if (variant && variant.available) {
        addToCartButton.disabled = false;
        addToCartButton.textContent = 'Add to cart';
      } else {

        addToCartButton.disabled = true;
        addToCartButton.textContent = 'Sold out';
      }
    }

    productForm.addEventListener("change", () => {
      const selectedOptions = getSelectedOptions(productForm);
      const variantId = findVariantId(selectedOptions);

      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantId) {
        variantInput.value = variantId;
        variantInput.disabled = false;
      } else if (variantInput) {
        variantInput.disabled = true;
      }

      updateButtonState(variantId);
    });

    // Initialize button state on page load
    const initialVariantId = document.querySelector('input[name="id"]')?.value;

    productForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          body: formData
        });
        if (!res.ok) throw new Error("Add to cart failed");

        // Update cart drawer
        const event = new Event("cart:updated"); // Custom event
        window.dispatchEvent(event);

        // Show drawer
        cartDrawer.classList.add("active");
      } catch (err) {
        console.error(err);
        alert("Could not add to cart. Please try again.");
      }
    });
  });

  
  } catch(e) { console.error(e); }
})();
})();
